import React, { Component } from "react"
import Layout from "../shared/components/organisms/layout/layout"
import SEO from "../components/seo"
import "../shared/styles/index.scss"
import RecoverContent from "../components/organisms/recover-content/recover-content"

class Recuperar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobile: false,
      modalActive: null,
    }
  }

  componentDidMount() {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    }
    window.addEventListener("resize", this.updateDimensions)
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions)
  }

  setModalACtive = modal => {
    this.setState({
      modalActive: modal,
    })
  }

  updateDimensions = () => {
    if (window.innerWidth < 1024) {
      this.setState({
        mobile: true,
      })
    } else {
      this.setState({
        mobile: false,
      })
    }
  }

  render() {
    return (
      <Layout mobile={this.state.mobile} modalActive={this.state.modalActive} title="Recuperación" >
        <SEO title="Recuperación" description="Recupera tu contraseña" url={"/login/recuperar/"}/>
        <RecoverContent
          mobile={this.state.mobile}
          setModalACtive={this.setModalACtive}
        />
      </Layout>
    )
  }
}

export default Recuperar
